import { render } from "./ErrorDisplay.vue?vue&type=template&id=3c88e71e&scoped=true"
import script from "./ErrorDisplay.vue?vue&type=script&lang=js"
export * from "./ErrorDisplay.vue?vue&type=script&lang=js"

import "./ErrorDisplay.vue?vue&type=style&index=0&id=3c88e71e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c88e71e"]])

export default __exports__